import { render, staticRenderFns } from "./AbkInvitationBox.vue?vue&type=template&id=20c3ca63&scoped=true&"
import script from "./AbkInvitationBox.vue?vue&type=script&lang=js&"
export * from "./AbkInvitationBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkInvitationBox.vue?vue&type=style&index=0&id=20c3ca63&scoped=true&lang=scss&"
import style1 from "./AbkInvitationBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3ca63",
  null
  
)

export default component.exports